var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},_vm._l((_vm.postsByCategory),function(posts){return _c('posts-carousel',{key:posts.id,staticClass:"posts-carousel",attrs:{"carouselId":posts.id,"sectionTitle":posts.sectionTitle,"posts":posts.data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }